import React from "react"
import PropTypes from "prop-types"

export const DragHandle = ({ height = 16, width = 16, fill = "currentColor", ...props }) => (
  <svg width={width} height={height} viewBox="0 0 16 16" fill={fill} xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...props}>
    <circle cx="5.5" cy="3" r="1.25" />
    <circle cx="10.5" cy="3" r="1.25" />
    <circle cx="5.5" cy="8" r="1.25" />
    <circle cx="10.5" cy="8" r="1.25" />
    <circle cx="5.5" cy="13" r="1.25" />
    <circle cx="10.5" cy="13" r="1.25" />
  </svg>
)

DragHandle.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  fill: PropTypes.string
}
